/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useEffect } from 'react';

import { cssMap, jsx } from '@compiled/react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import {
	ANALYTICS_CHANNEL,
	ANALYTICS_SOURCE,
	ANALYTICS_TAG,
} from '@atlassian/universal-create-common';

import { SkeletonItem } from '../SkeletonItem';

const styles = cssMap({
	wrapper: {
		minWidth: '246px',
	},
	wrapperWithPadding: {
		minWidth: '246px',
		paddingTop: token('space.100'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.200'),
	},
});

export function LoadingMenu({ padded = false }: { padded?: boolean }) {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		// Intentional inline this analytics events due to
		// loading menu component can be used outside of context
		if (fg('navx-3262-loading-menu-viewed')) {
			createAnalyticsEvent({
				actionSubject: 'universalCreate',
				eventType: 'ui',
				source: ANALYTICS_SOURCE,
				tags: [ANALYTICS_TAG],
				action: 'viewed',
				actionSubjectId: 'universalCreateLoadingMenu',
				attributes: {},
			}).fire(ANALYTICS_CHANNEL);
		}
	}, [createAnalyticsEvent]);

	return (
		<Box
			testId="global-create-content-loading-menu"
			xcss={padded ? styles.wrapperWithPadding : styles.wrapper}
		>
			{Array.from({ length: 6 }, (_, index) => (
				<SkeletonItem key={`loading-skeleton-item-${index}`} contentHeight={8} />
			))}
		</Box>
	);
}
